import { render } from "./Appendix.vue?vue&type=template&id=acb0a1b4&scoped=true"
import script from "./Appendix.vue?vue&type=script&lang=js"
export * from "./Appendix.vue?vue&type=script&lang=js"

import "./Appendix.vue?vue&type=style&index=0&id=acb0a1b4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb0a1b4"]])

export default __exports__